import React, { PureComponent } from 'react'
import Head from "next/head";
import NProgress from "components/NProgress";
import SeoMeta from '/components/seoMeta';
import { duwunCoverLogo } from '/utils/common';

export default class SubscribeNoti extends PureComponent {
    render() {
        return (
            <div>
              <Head>
                <title>Subscribe Us</title>
              </Head>
              <SeoMeta 
                  url={`${process.env.BACKEND_URL}/subscribe-noti`} 
                  type="article"
                  title='Subscribe to notification'
                  description="Subscribe to push notification from Duwun Media"
                  image={duwunCoverLogo}
                  section='Subscribe-noti'
                  keywords='Subscribe-noti'
                />        
              <NProgress />
            </div>
          );
    }
}
